<template>
  <div class="salesorder"> 
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" >  
        <HeaderPage @sword-id="getBreadcrumps($event)" hasInputWord=true />
      </v-col>
    </v-row>


    <v-card
        flat
        class="py-12"
      >
        <v-card-text >
          <v-row class="text-right" justify="center" >        
            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
            >
                      
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">    
                    <router-link to="/salesorder-add">
                    <v-btn                  
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </router-link>
                  </template>
                  <span>Agregar Nueva Venta</span>
                </v-tooltip>
            </template>                  

            <!-- Dialog para agregar Cliente --> 
        <template>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }"> 
                <v-btn
                color="darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-dialog
                    v-model="dialog2"
                    persistent
                    max-width="600px"                 
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                  color="darken-2"                                  
                        v-bind="attrs"
                        v-on="on"
                        plain
                      >
                        <v-icon>group_add</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                          <span class="headline">Agregar Cliente</span>
                          <v-btn
                            class="headline"
                            color="blue darken-1"
                            text
                            @click="dialog2 = false"
                          >
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-container> 
                            <CustomerCreate  />
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>          
                          <small style="color:red;">*Campos Obligatorios</small>
                        </v-card-actions>
                      </v-card>
                      </v-dialog>
                </v-btn>                
              </template>
              <span>Agregar Nuevo Cliente</span>
            </v-tooltip>
        </template> 
        <!-- fin dialgo Cliente -->
            
                      
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">              
                    <v-btn
                      @click="getSalesOrder('')" 
                      color="primary darken-5"               
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon>refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Refrescar Página</span>
                </v-tooltip>
            </template>

            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">              
                    <v-btn
                      @click="$router.back()" 
                      color="primary darken-2"               
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon>arrow_back</v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar a la Página Anterior</span>
                </v-tooltip>
            </template>
              
              
            </v-btn-toggle>
          </v-row>
      </v-card-text>
    </v-card>


    <v-row>
      <v-col cols=12 sm=12 md=12 lg=12>   
        <table>
          <tr>
            <td style="text-align:left; font-size:1.1rem;"></td> 
            <td style="text-align:right; font-size:1.1rem;"><b>Total IVA:</b> {{ totaliva | currency }}</td> 
          </tr>
        </table>
      </v-col>
    </v-row> 


  <!-- Busqueda SalesOrder -->
  <SalesOrderItem :salesorders="salesorders"  />
  <!-- FIN Busqueda SalesOrder -->

  </div>
</template>

<script>
// import axios from "axios";
import{ mapMutations, mapState } from "vuex";
import HeaderPage from '@/components/HeaderPage.vue'
import CustomerCreate from '@/components/CustomerCreate.vue'
// import baseApi from '@/services/baseApi';
import SalesOrderItem from "@/components/SalesOrderItem";


export default {
  name: 'salesorder',  
  computed:{
      ...mapState(['salesorders','customers'])    
  },
  components: {
    HeaderPage,
    CustomerCreate,
    SalesOrderItem

  },
  data(){
     return{
      dialog: false,
      dialog2:false,
      toggle_exclusive:'',
      attribute: {sword: '',limit: 500},
      sword:"",
      totaliva:0, 
    }
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    /*
    const formatear = ("0" + date.getDate()).slice(-2) + "-" + ("0"+(date.getMonth()+1)).slice(-2) + "-" +
                            date.getFullYear() + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":"
                            + ("0" + date.getSeconds()).slice(-2);   
          // Mostramos la fecha y hora en la consola           
    */
    
    async getSalesOrder(sword){    
      try{        
        this.showLoading({titulo:"Accediendo información",color:"primary"})        
        await this.$store.dispatch('loadSalesOrders',sword);
        //console.log(this.salesorders[0].iva_salesorders) 
        for (var i = 0; i < this.salesorders.length; i+=1) { 
          //console.log(this.salesorders[i].iva_salesorders)
          this.totaliva+=this.salesorders[i].iva_salesorders;              
        }
               
      }catch(error){
        //console.log(error);
      }  finally{
        this.hiddenLoading()
      } 
    },
    async getBreadcrumps(sword){  
      this.getSalesOrder(sword);       
    },
  },
  created(){
    this.changeBreadcrumbs({
        page:"Ventas",
        title:"Ventas",
        subtitle:"primary",
        description:"En esta lista encontrará todas las ventas dados de alta en el sistema desde el principio de los tiempos"
    });
    this.getBreadcrumps(this.sword)    
    
    //iva_salesorders
  },
}
</script>
<style>
  .v-date-picker-table {    
    height: auto;
  }
</style>